import { AccessBehaviorProps } from "../AccessGate.types";

/**
 * Behavior that completely hides the children when access is blocked.
 *
 * This is the simplest behavior — equivalent to what `<Can>` does today.
 *
 * @example
 * <AccessGate strategy={access} behavior={HideBehavior}>
 *   <AdminPanel />
 * </AccessGate>
 */
export function HideBehavior(_props: AccessBehaviorProps) {
    return null;
}
